import gql from 'graphql-tag'

export const SIGNUP_USER = gql`
  mutation SignupUserMutation(
    $email: String!
    $password: String!
    $name: String!
  ) {
    signupUser(email: $email, password: $password, name: $name) {
      token
      id
    }
  }
`

export const AUTHENTICATE_USER = gql`
  mutation AuthenticateUserMutation($email: String!, $password: String!) {
    authenticateUser(email: $email, password: $password) {
      token
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/user.js